const ALGOLIA_INDICES = {
  SITE: {
    MAIN: 'site-pages',
  },
  EMPTY_RECORD_TITLE: 'Homepage',
}

export default ALGOLIA_INDICES
